import {createSubscription} from '@api/subscription';
import {isApiError} from '@utils/errorUtils';
import isObject from 'lodash.isobject';
import type {ReactElement} from 'react';
import {useState} from 'react';
import type {FormikBag} from 'formik';
import {Formik} from 'formik';
import InnerForm from '@components/SubscriptionForm/InnerForm';
import validationSchema from '@components/SubscriptionForm/validationSchema';
import {EMAIL} from '@constants/subscription';
import type {FreeSubscription} from '@interfaces/Subscription';
import Analytics from '@services/analytics/Analytics';

interface Props {
    code: string;
    isBlock?: boolean;
    isLargeButton?: boolean;
}

export default function SubscribeForm(props: Props): ReactElement {
    const [isSuccess, setIsSuccess] = useState(false);

    function handleSubmit(values: FreeSubscription, formikBag: FormikBag<Props, FreeSubscription>) {
        formikBag.setStatus(undefined);

        Analytics.triggerEvent(
            `Клик на кнопку Подписаться в форме подписки (${props.code})`,
            'click',
            {
                code: props.code,
            },
        );

        void createSubscription(props.code, values)
            .then(() => {
                Analytics.triggerEventWithPayment({
                    eventName: `Успешная бесплатная подписка (${props.code})`,
                    eventType: 'subscribe',
                    eventLabel: props.code,
                    price: 0,
                    currency: 'RUB',
                });
                setIsSuccess(true);
            })
            .catch((error: unknown) => {
                if (
                    isApiError(error) &&
                    isObject(error.payload) &&
                    Object.keys(error.payload).length > 0
                ) {
                    formikBag.setErrors(error.payload);
                } else {
                    formikBag.setStatus('Что-то пошло не так. Попробуйте перезагрузить страницу');
                }
            })
            .then(() => formikBag.setSubmitting(false));
    }

    if (isSuccess) {
        return <div className="subscribe-form--success">Спасибо! Вы подписаны.</div>;
    }

    return (
        <Formik
            onSubmit={handleSubmit}
            initialValues={{
                [EMAIL]: '',
            }}
            validationSchema={validationSchema}
        >
            <InnerForm
                isBlock={props.isBlock ?? false}
                isLargeButton={props.isLargeButton ?? false}
            />
        </Formik>
    );
}
